module.exports = __webpack_public_path__ + "img/Backup.2f6ed0b2.svg";